enum UnregisteredCustomerType {
  Customer = 'Customer',
  Lead = 'Lead',
  CustomerAndLead = 'CustomerAndLead',
}

export default UnregisteredCustomerType;
